<template>
  <!-- 전역 모달 호스트 — store.activeModal 값에 따라 해당 모달을 지연 로드해 렌더 -->
  <component
    :is="activeComponent"
    v-if="activeComponent"
    @close="onClose"
  />
</template>

<script>
import { defineAsyncComponent } from "vue";

// 액션키 → 모달 컴포넌트 레지스트리.
// Core 가 모듈을 정적 import 하지 않도록 dynamic import(지연 로드) 사용.
const registry = {
  // 협업 Space 생성 = 멤버(호출 대상) 선택 팝업 → 선택 시 Space 생성 + 초대 + Zone 진입
  "remote:createSpace": defineAsyncComponent(() =>
    import("@modules/remote/components/ModalRemoteCallInvite.vue"),
  ),
};

export default {
  name: "GlobalModalHost",
  computed: {
    activeKey() {
      return this.$store.getters.activeModal;
    },
    activeComponent() {
      return this.activeKey ? registry[this.activeKey] || null : null;
    },
  },
  methods: {
    onClose(payload) {
      const key = this.activeKey;
      this.$store.dispatch("closeModal");

      // 협업 Space 생성 성공(@close {result:true}) → 협업 Zone 으로 이동
      if (key === "remote:createSpace" && payload && payload.result) {
        this.$router.push("/remote/zone").catch(() => {});
      }
    },
  },
};
</script>
